import koLocale from 'element-ui/lib/locale/lang/ko'
export default {
	all:{
		jiantizhongwen:'간체 중국어',
		fantizhongwen:'번체 중국어',
		yingwen:'영어',
		ribenyu:'일본어',
		hanguoyu:'한국어',
		jizhuzhanghao:'계정 기억',
		jizhumima:'비밀번호 기억',
		yuyanxuanze:'언어 선택',
		shezhi:'설정',
		xiugaimima:'비밀번호 변경',
		yinsizhengce:'개인정보 보호 정책',
		guanyuwomen:'우리에 대하여',
		mimashuoming:'비밀번호는 8~20자 대소문자와 숫자의 조합이어야 하며, 순수 숫자 또는 순수 영문은 안 됩니다',
		qingshurujiumima:'기존 비밀번호를 입력해주세요',
		qingshuruxinmima:'새 비밀번호를 입력해주세요',
		quedingxiugai:'변경 확인',
		
		shouye:'홈',
		zhibo:'라이브',
		wode:'마이페이지',
		xitongxiaoxi:'시스템 메시지',
		wodedingdan:'내 주문',
		bangzhufankui:'도움 및 피드백',
		xiugaiziliao:'프로필 수정',
		xiaofeimingxi:'소비 내역',
		zhibojilu:'라이브 기록',
		tijiao:'제출',
		caozuochenggong:'작업 성공',
		tishi:'알림',
		quedingtuichudengluma:'로그아웃 하시겠습니까?',
		queding:'확인',
		wentibangzhu:'문제 도움',
		woyaofankui:'피드백',
		fankuiwenti:'피드백 문제',
		qingmiaoshuniyaofankuidewenti:'피드백하고 싶은 문제를 설명해주세요...',
		sousuo:'검색',
		sousuoniganxingqudeneirong:'관심 있는 내용 검색',
		zhibojianbiaoti:'라이브 제목',
		zhibojianbeijing:'라이브 배경',
		xuanzebackground:'배경 선택',
		shangchuanbeijing:'배경 업로드',
		yixuanze:'선택됨',
		qingxuanzebeijing:'배경을 선택해주세요',
		zhibojianbiaoqian:'라이브 태그',
		zhibojianhuazhi:'라이브 화질',
		geinidezhibojianqugemingziba:'라이브 방에 이름을 지어주세요~',
		qingshurukaibomiyao:'스트림 키를 입력해주세요',
		kaishizhibo:'라이브 시작',
		shengyin:'소리',
		liwutexiao:'선물 효과',
		gengduo:'더 보기',
		gouwuche:'쇼핑 카트',
		zaixianguanzhong:'온라인 시청자',
		danmushuoming:'플랫폼은 미성년자의 충전 및 팁을 엄격히 금지합니다. 동료 놀이 등으로 팁을 유도하거나 개인 거래하는 행위를 금지합니다. 음란물, 정치적 내용, 욕설 등을 금지합니다. 재산 안전에 유의하시고, 인터넷 사기에 주의하세요. 합리적인 소비를 해주세요.',
		tianjiaguanliyuan:'관리자 추가',
		jinyan:'음소거',
		jiechuejinyan:'음소거 해제',
		tichufangjian:'방에서 추방',
		shangpinxiangqing:'상품 상세',
		lijijiagou:'즉시 구매',
		xuanzeguige:'규격 선택',
		quanbuliwu:'모든 선물',
		ge:'개',
		bi:'코인',
		guanliyuan:'관리자',
		kuaijieduanyu:'빠른 문구',
		gonggao:'공지',
		xinzengkuaijieduanyu:'새 빠른 문구',
		qingshuru:'입력해주세요',
		qingshuruzhengque:'올바른 금액을 입력해주세요',
		shuru:'입력',
		wangjimima:'비밀번호를 잊으셨나요',
		youxiangzhuce:'이메일 등록',
		huoquyanzhengma:'인증 코드 받기',
		qingshuruningdeyouxiangzhanghao:'이메일 계정을 입력해주세요',
		qingshuruyanzhengma:'인증 코드를 입력해주세요',
		qingshurumima:'비밀번호를 입력해주세요',
		mimadenglu:'비밀번호 로그인',
		woyiyuedubingtongyi:'읽었습니다. 동의합니다',
		yonghuxieyi:'이용 약관',
		yinsixieyi:'개인정보 보호 약관',
		denglu:'로그인',
		chongxindenglu:'다시 로그인',
		xiayibu:'다음 단계',
		haimeizhanghao:'아직 계정이 없으신가요',
		quzhuce:'가입하러 가기',
		yiyouzhanghao:'이미 계정이 있으신가요',
		qudenglu:'로그인하러 가기',
		shezhijibenxinxi:'기본 정보 설정',
		nichengtishi:'영문, 숫자, 구두점만 사용 가능합니다. 최소 6자, 공백은 사용할 수 없습니다',
		shezhiyonghuming:'사용자 이름 설정',
		yonghumingtishi:'사용자 이름은 6~18자 대소문자 또는 숫자입니다',
		shezhijiaoyimima:'거래 비밀번호 설정',
		jiaoyimimatishi:'거래 비밀번호는 6자리 숫자의 조합이어야 합니다',
		qingxuanze:'선택해주세요',
		yaoqingma:'초대 코드 (선택)',
		qingshuruyaoqingma:'초대 코드를 입력해주세요',
		shezhixinmima:'새 비밀번호 설정',
		xuanzeningdeguojia:'국가를 선택해주세요',
		zhuce:'가입',
		qingshuruyonghuming:'사용자 이름을 입력해주세요',
		gaoqinghuazhi:'고화질',
		putonghuazhi:'보통 화질',
		zengsong:'선물하기',
		jinrulezhibojian:'라이브 방에 입장',
		shuodianshenmene:'무엇을 말하고 싶으신가요...',
		zanwushuju:'데이터 없음',
		songgei:'선물하기',
		huifang:'재생',
		xunibi:'가상 화폐',
		quanbu:'모든',
		appxiazai:'앱 다운로드',
		dingdanjine:'주문 금액',
		dingdanbianhao:'주문 번호',
		chuangjianshijian:'생성 시간',
		zhubozanshilikai:'방송인이 일시적으로 떠났습니다',
		mashanghuilai:'곧 돌아옵니다',
		guojianzhuoxiazai:'국제 버전 안드로이드 다운로드',
		anzhuoxiazai:'안드로이드 다운로드',
		guojipingguoxiazai:'국제 버전 iOS 다운로드',
		pingguoxiazai:'iOS 다운로드',
		weixiazai:'다운로드 없음',
		quanbushangpin:'모든 상품',
		yiqiangguang:'품절',
		jiagou:'장바구니에 추가',
		yixuan:'선택됨',
		xuazeguige:'규격 선택',
		shangchuanzhong:'업로드 중',
		shangchuanshibai:'업로드 실패',
		shifouquedingjieshuzhibo:'라이브를 종료하시겠습니까?',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'이용 약관과 개인정보 보호 약관을 읽고 동의해주세요!',
		quedingqudengluma:'로그인하시겠습니까?',
		duanyingyin:'단영상',
		fabuduanyingyin:'단영상 게시',
		zhibohuaxu:'라이브 하이라이트',
		qingshurubiaoti:'제목을 입력해주세요',
		shangchuanduanyingyin:'단영상 업로드',
		zhibozhongxin:'라이브 센터',
		zongzichanguzhi:'총 자산 가치',
		liushuijilu:'거래 내역',
		chongbi:'입금',
		tibi:'출금',
		gaibizhongbuzhichichongzhi:'해당 통화는 입금을 지원하지 않습니다',
		gaibizhongbuzhichitibi:'해당 통화는 출금을 지원하지 않습니다',
		dashang:'팁',
		riqi:'날짜',
		leixing:'유형',
		miaoshu:'설명',
		jine:'금액',
		zhuangtai:'상태',
		yiwancheng:'완료',
		shenhezhong:'심사 중',
		shenhejujue:'심사 거절',
		kaishiriqi:'시작일',
		jieshuriqi:'종료일',
		wangluo:'네트워크',
		dizhi:'주소',
		tibishuliang:'출금 금액',
		daozhangshisuan:'도착 예측',
		shouxufei:'수수료',
		meiridaozhang:'매일 도착',
		keyong:'사용 가능',
		dongjie:'동결',
		zuixiaotibishuliang:'최소 출금 금액',
		shouxufeibilv:'수수료',
		meirishenyueddu:'일일 잔여 한도',
		shenqingzhibo:'라이브 신청',
		shenqingjilu:'신청 기록',
		huifangjilu:'다시보기 기록',
		yikaifang:'개방됨',
		guankanhuifang:'다시보기',
		beisu:'배속',
		zhiboriqi:'방송 날짜',
		shijianshiduan:'시간대',
		shoujizhibo:'모바일 방송',
		zhibodaihuo:'라이브 커머스',
		kaiqi:'켜기',
		guanbi:'끄기',
		beizhu:'비고',
		huodongzhuti:'활동 주제, 장비 설명',
		shenqinghouliucheng:'신청 후 절차',
		shenqinghouliuchengdesc:'승인 후 방송 주소가 이메일로 발송됩니다.',
		daishenhe:'심사 대기',
		tijiaoshenqing:'신청 제출',
		qingxuanzeriqi:'방송 날짜를 선택해주세요',
		qingxuanzeshijian:'시간대를 선택해주세요',
		tijiaochenggong:'제출 성공',
		nian:'년',
		yue:'월',
		tongshiduanbukezhongfu:'같은 시간대 중복 불가',
		keshenqingshiduan:'신청 가능 시간대',
		querenShiduan:'확인',
		zhanghaoid:'계정 ID',
		qingtianxie:'입력해주세요',
		zhou1:'월',
		zhou2:'화',
		zhou3:'수',
		zhou4:'목',
		zhou5:'금',
		zhou6:'토',
		zhou7:'일',
		shenqingyitijiao:'신청이 제출되었습니다',
		shenqingtijiaodesc:'관리자가 방송방, 시간대 및 상품 정보를 심사합니다.',
		chakanshenheJilu:'심사 기록 보기',
		shenqingriqi:'신청일',
		zhiboshijianduan:'방송 시간대',
		zhiboleixing:'방송 유형',
		daihuo:'라이브 커머스',
		yitongguo:'승인됨',
		weitongguo:'미승인',
		xiangqing:'상세',
		yuanyin:'사유',
		shenqingxiangqing:'신청 상세',
		shenheyuanyin:'심사 사유',
		xutiaozheng:'조정 필요',
		shenheyuanyindesc:'해당 시간대가 이미 사용 중입니다. 다른 날짜 또는 시간대를 선택하여 다시 제출해주세요.',
		wancheng:'완료',
		chulizhong:'처리 중',
		daichuli:'처리 대기',
		houtaishenhe:'관리자 심사',
		chanshengmiyao:'키 생성',
		youjiankuaidi:'이메일 알림',
		kechakan:'열람 가능',
		jinwanxinpinfuli:'오늘 밤 신상품 라이브',
		chehuishenqing:'신청 철회',
		chongxinshenqing:'다시 신청',
		zhibojinyao:'방송 키',
		zhibojian:'방송방',
		keyongshiduan:'사용 가능 시간',
		youxiao:'유효',
		tuiliudizhi:'푸시 URL',
		tuiliumamiyao:'스트림 키',
		youjiantongzhidesc:'같은 방과 시간대에서는 키가 다시 생성되지 않습니다.',
		yifasong:'발송됨',
		fuzhiquanbu:'전체 복사',
		fuzhichenggong:'복사 성공',
		youjiantongzhi:'이메일 알림',
		zhiboshenhetongguo:'방송 승인됨',
		shoujianren:'수신자',
		youjianneirongdesc:'방송방, 사용 가능 시간대, 푸시/풀 URL, 키 및 방송 전 설정 입구를 포함합니다',
		youjianbianhao:'메일 ID',
		chongxinfasong:'재발송',
		yinyuedaren:'음악',
		wudaodaren:'댄스',
		yanzhi:'비주얼',
		jichushezhi:'기본 설정',
		yishangchuan:'업로드됨',
		zhiboshangpin:'방송 상품',
		laiziyunimall:'UNImall 스토어에서',
		jian:'개',
		zhiboliucheng:'방송 절차',
		liuchang:'원활',
		gaoqing:'HD',
		chaoqing:'울트라 HD',
		languang:'블루레이',
		tongguo:'통과',
		jinxingzhong:'진행 중',
		daikaiqi:'대기',
		qianzhizuoye:'사전 설정',
		qingshangchuan:'업로드',
		shangpinxuhao:'번호',
		shangpinshoutu:'상품 이미지',
		shangpinmingcheng:'상품명',
		shangchengkucun:'스토어 재고',
		zhibokucun:'방송 재고',
		shangchengjiage:'스토어 가격',
		zhibojiage:'방송 가격',
		caozuo:'작업',
		yichu:'삭제',
		zhibojiansetting:'방 설정',
		kaiqishengyin:'소리 켜기',
		guanbishengyin:'소리 끄기',
		kaiqidanmu:'탄막 켜기',
		guanbidanmu:'탄막 끄기',
		kaiqimeiyan:'뷰티 켜기',
		guanbimeiyan:'뷰티 끄기',
		kaiqimaikefeng:'마이크 켜기',
		guanbimaikefeng:'마이크 끄기',
		kaiqimaike:'마이크 켜기',
		guanbimaike:'마이크 끄기',
		gonggao:'공지',
		fenxianglianjie:'링크 공유',
		xietongzhibo:'협동 방송',
		yaoqingjinbo:'보조 진행자 초대',
		tongyikongzhi:'통합 제어',
		tichuzhubozb:'선택 제거',
		zhuborenshushangxian:'보조 진행자 상한',
		ren:'명',
		tongzhibojinyao:'방송 키와 동일',
		zhuboquanxian:'보조 진행자 권한',
		yunxufayan:'발언 허용',
		yunxukamai:'마이크 허용',
		yunxukashipin:'비디오 허용',
		yikaiqi:'활성화됨',
		shengchengyaoqingjinyao:'초대 키 생성',
		xietongzhiborenshu:'협동 방송 인원',
		dangqianzhibo:'현재 보조 진행자',
		kenenghaiyaoqing:'추가 초대 가능',
		weizhibo:'명',
		baocunshangxian:'상한 저장',
		fenxiangyaoqing:'초대 공유',
		yaoqinglianjie:'초대 링크',
		fenxiangfangshi:'공유 방법',
		fuzhilianjie:'링크 복사',
		baocunerweima:'QR코드 저장',
		fuzhiyaoqinglianjie:'초대 링크 복사',
		zhubo:'보조 진행자',
		guanli:'관리',
		yijinru:'입장함',
		maikefeng:'마이크',
		shexiangtou:'카메라',
		guanbishexiangtou:'카메라 끄기',
		kaiqishexiangtou:'카메라 켜기',
		guanbijingxiang:'미러 끄기',
		kaiqijingxiang:'미러 켜기',
		sheweizhuyemian:'메인 화면으로 설정',
		quxiaozhuyemian:'메인 화면 해제',
		tichuzhibo:'방송방에서 제거',
		tichuhoubukejinru:'제거 후 재입장 불가',
		tongyikongmai:'통합 마이크 제어',
		quanjukongzhi:'전체 제어',
		quantijingyin:'전체 음소거',
		yunxuzhubokaimai:'보조 진행자 마이크 허용',
		yunxuzhubokaishipin:'보조 진행자 비디오 허용',
		huifukaimai:'음소거 해제',
		guanbishipin:'비디오 끄기',
		kaiqishipin:'비디오 켜기',
		yunxushipin:'비디오 허용',
		yingyongshezhi:'설정 적용',
		shipin:'비디오',
	kaimai:'마이크 켜짐',
	weikaiqi:'꺼짐',
	shipinkaiqi:'비디오 켜짐',
	shipinguanbi:'비디오 꺼짐',
	bimai:'음소거',
	yunxufayan:'채팅 허용',
	jinzhifayan:'채팅 금지',
	zhuboxiwei:'코호스트 좌석',
		guankanzhibo:'시청하기',
		goumai:'구매',
		goumaishangpin:'상품 구매',
		yishouqing:'매진',
		dashang:'선물',
		chakangg:'공지 확인',
		quxiao:'취소',
		queren:'확인',
		wodequanbao:'내 지갑',
		jiangjie:'설명',
		jiangjiezhong:'설명 중',
		kucun:'재고',
		qrcodenotexist:'QR코드를 찾을 수 없습니다',
		qrcodesaved:'QR코드를 저장했습니다',
		wodeqianbao:'내 지갑',
		lianshangbaobishibei:'온체인 토큰',
		zonge:'총액',
		keyongshuliang:'사용 가능',
		dongjieshuliang:'동결',
		chakanliushui:'거래 내역 보기',
		chongzhitip:'같은 체인만 지원됩니다. 블록체인 확인 후 전송은 취소할 수 없습니다.',
		chongzhishuliang:'입금액',
		zuidicharge:'최소 입금 금액 ',
		yujidaozhang:'도착 예정',
		shijidaozhang:'실제 도착',
		lijichongzhi:'즉시 입금',
		chongzhierweima:'입금 QR코드',
		chongbidizhi:'입금 주소',
		fuzhidizhi:'주소 복사',
		chongzhichenggong:'입금 성공',
		dengdaiquerenzhong:'확인 대기 중...',
		baocunchenggong:'저장 완료',
		chongbichenggong:'입금 완료',
		bizhong:'토큰',
		shuliang:'수량',
		shijian:'시간',
		tibidizhi:'출금 주소',
		qingshurutibidizhi:'출금 주소를 입력하세요',
		tibishisuan:'출금 예상',
		zuiditixianjin:'최소 출금 금액',
		meiriyushutixian:'매일 남은 출금 금액',
		keyongyu:'사용 가능 잔액',
		tijiaotibi:'출금 제출',
		xuanzetibidizhi:'출금 주소 선택',
		sousuodizhi:'주소 검색',
		xuanze:'선택',
		querentbi:'출금 확인',
		xuanzedashangbizhong:'선물 토큰 선택',
		yue:'잔액',
		dashangjine:'선물 금액',
		zhanshidashangxinxi:'선물 정보 보기',
		zidingyi:'직접 입력',
		querendashang:'선물 확인',
		zaixianguanzhong:'시청자',
		yizhibo:'방송 중',
		jieshizhibo:'방송 종료',
		zhibozhong:'방송 중',
		zanwuzaixianguanzhong:'시청자가 없습니다',
		shangchuanshibai:'비디오 업로드에 실패했습니다. 나중에 다시 시도해주세요',
		qingshurucontent:'제목을 입력하고 비디오를 업로드해주세요',
		fabuchenggong:'게시 성공',
		fabushibai:'게시 실패',
		qingshurushuju:'데이터를 입력해주세요',
		confirmDelete:'이 비디오를 삭제하시겠습니까?',
		shanchuchenggong:'삭제 성공',
		confirmWithdraw:'이 비디오를 철회하시겠습니까?',
		chehuichenggong:'철회 성공',
		yongjiujinyan:'영구 밴',
		jiaruzhibo:'라이브 참가',
		jiaruxietongzhibo:'협동 라이브 참가',
		tuichuxietongzhibo:'협동 라이브 탈퇴',
		zhubojinyao:'협동 라이브 키',
		qingshuruzhubojinyao:'협동 라이브 키를 입력해주세요',
		jiaru:'참가',
		shenqingchenggong:'신청 성공',
		youxiaoqi:'유효 기간',
		tichubenchang:'강퇴',
		zhanshidashangxiaoxi:'팁 메시지 표시',
		zanwugonggao:'공지사항 없음',
		dashang:'팁',
		songgei:'보냄',
		ge:'개',
		bi:'코인',
		zanweiyourenjiaruxietongzhibo:'아직 공동 방송에 참여한 사람이 없습니다',
		zanweikaiqi:'공동 방송이 아직 활성화되지 않았습니다'
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/ko.js